import axios from "../utils/axios";

export async function fetchUserDetails() {
    const response = await axios.get(`/user`);
    return response.data;
}

export async function updateDefaultPractice(defaultPracticeId: string | null) {
    const response = await axios.patch(`/user/default-practice`, {
        default_practice_id: defaultPracticeId,
    });
    return response.data;
}

export async function syncGoogleName() {
    const response = await axios.post(`/user/sync-google-name`, undefined, {
        skipUnauthorizedLogout: true,
    });
    return response.data;
}
